const globals = {
  state: {
    message: null,
    loading: false,
    snackbar: false,
    snackbarText: null,
  },
  mutations: {
    SET_GLOBAL_MESSAGE: (state, message) => {
      state.message = message;
    },
    SET_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_SNACKBAR: (state, snackbar) => {
      state.snackbar = snackbar;
    },
    SET_SNACKBAR_TEXT: (state, snackbarText) => {
      state.snackbarText = snackbarText;
    },
  },
  actions: {
    setGlobalMessage({ commit }, global) {
      commit("SET_GLOBAL_MESSAGE", global.message);
    },
    setLoading({ commit }, global) {
      commit("SET_LOADING", global.loading);
    },
    setSnackbar({ commit }, global) {
      commit("SET_SNACKBAR", global.snackbar);
    },
    setSnackbarText({ commit }, global) {
      commit("SET_SNACKBAR_TEXT", global.snackbarText);
    },
  },
  getters: {
    global: (state) => state,
  },
};

export default globals;
